import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFolders = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Folders",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M12.4688 3.0625H8.75L7.29148 1.96875C7.10194 1.82718 6.87181 1.75047 6.63523 1.75H4.15625C3.86617 1.75 3.58797 1.86523 3.38285 2.07035C3.17773 2.27547 3.0625 2.55367 3.0625 2.84375V3.9375H1.96875C1.67867 3.9375 1.40047 4.05273 1.19535 4.25785C0.990234 4.46297 0.875 4.74117 0.875 5.03125V11.1562C0.875 11.4463 0.990234 11.7245 1.19535 11.9296C1.40047 12.1348 1.67867 12.25 1.96875 12.25H10.3299C10.607 12.2497 10.8727 12.1395 11.0686 11.9436C11.2645 11.7477 11.3747 11.482 11.375 11.2049V10.0625H12.5174C12.7945 10.0622 13.0602 9.95201 13.2561 9.75608C13.452 9.56016 13.5622 9.29451 13.5625 9.01742V4.15625C13.5625 3.86617 13.4473 3.58797 13.2421 3.38285C13.037 3.17773 12.7588 3.0625 12.4688 3.0625ZM10.0625 10.9375H2.1875V5.25H4.375L5.83352 6.34375C6.02306 6.48532 6.25319 6.56203 6.48977 6.5625H10.0625V10.9375ZM12.25 8.75H11.375V6.34375C11.375 6.05367 11.2598 5.77547 11.0546 5.57035C10.8495 5.36523 10.5713 5.25 10.2812 5.25H6.5625L5.10398 4.15625C4.91444 4.01468 4.68431 3.93797 4.44773 3.9375H4.375V3.0625H6.5625L8.02102 4.15625C8.21056 4.29782 8.44069 4.37453 8.67727 4.375H12.25V8.75Z",
			fill: "currentColor"
		})
	})
});
export default SvgFolders;
